<template>
  <v-container fill-height fluid>
    <div class="logo"></div>
    <v-btn
      to="about"
      small
      class="pl-5 about rounded-0 rounded-tl-xl"
      color="primary"
      >MER OM FAGKART APPLIKASJONEN</v-btn
    >
  </v-container>
</template>

<script>
export default {
  name: "Home"
};
</script>

<style scoped>
.logo {
  background: url("../assets/mitt-fagkart-plug.svg") center center no-repeat;
  background-size: contain;
  position: absolute;
  top: 40px;
  right: 40px;
  bottom: 40px;
  left: 40px;
}
.about {
  position: absolute;
  right: 0px;
  bottom: 0px;
}
</style>
